function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

//
import * as React from 'react';
import { css, StyleSheet } from "../../styles/theme";
import PropTypes from 'prop-types';
import { escapeStringRegex } from "../../utils/util";
import regExpPropTypes from "../../constants/regExpPropTypes";
var styles = StyleSheet.create({
  Highlighter: {}
});
/**
 * Get search props in the format of regular exp to keep consistency.
 */

function convertSearchToRegex(search, caseSensitive) {
  if (search instanceof RegExp) {
    return search;
  }

  var searchLocal = search;

  if (typeof searchLocal === 'string') {
    searchLocal = escapeStringRegex(search);

    if (!caseSensitive) {
      var flags = 'i';
      return new RegExp(searchLocal, flags);
    }

    return new RegExp(searchLocal);
  }

  return undefined;
}

function getMatchBoundaries(text, search) {
  var matches;

  if (search) {
    matches = search.exec(text);
  }

  if (matches) {
    return {
      first: matches.index,
      last: matches.index + matches[0].length
    };
  }

  return undefined;
}

function highlighterChildren(_ref) {
  var text = _ref.text,
      search = _ref.search,
      Tag = _ref.matchElement,
      matchClass = _ref.matchClass,
      matchStyle = _ref.matchStyle;
  var children = [];
  var remaining = text;
  var count = 0;
  var noMatch;
  var match;

  while (remaining) {
    if (search && !search.test(remaining)) {
      count += 1;
      children.push(React.createElement("span", {
        key: count
      }, remaining));
      return children;
    }

    var boundaries = getMatchBoundaries(remaining, search) || {};
    noMatch = remaining.slice(0, boundaries.first);

    if (noMatch) {
      count += 1;
      children.push(React.createElement("span", {
        key: count
      }, noMatch));
    }

    match = remaining.slice(boundaries.first, boundaries.last);

    if (match && Tag) {
      count += 1;
      children.push(React.createElement(Tag, {
        className: matchClass,
        style: matchStyle,
        key: count
      }, match));
    }

    remaining = remaining.slice(boundaries.last);
  }

  return children;
}

export default function Highlighter(_ref2) {
  var search = _ref2.search,
      caseSensitive = _ref2.caseSensitive,
      Tag = _ref2.matchElement,
      matchClass = _ref2.matchClass,
      matchStyle = _ref2.matchStyle,
      text = _ref2.text,
      _ref2$rootClassName = _ref2.rootClassName,
      rootClassName = _ref2$rootClassName === void 0 ? '' : _ref2$rootClassName,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? {} : _ref2$style,
      _ref2$htmlAttributes = _ref2.htmlAttributes,
      htmlAttributes = _ref2$htmlAttributes === void 0 ? {} : _ref2$htmlAttributes,
      rest = _objectWithoutProperties(_ref2, ["search", "caseSensitive", "matchElement", "matchClass", "matchStyle", "text", "rootClassName", "style", "htmlAttributes"]);

  var searchRegex = convertSearchToRegex(search, caseSensitive);
  var renderDirectHighlight = typeof search === 'boolean' && search;
  var renderSearch = !renderDirectHighlight && !!search;
  var renderPlain = !renderSearch && !renderDirectHighlight;
  return React.createElement("span", _extends({}, htmlAttributes, css(rootClassName, styles.Highlighter), rest, {
    style: style
  }), renderSearch && highlighterChildren({
    text: text,
    search: searchRegex,
    matchClass: matchClass,
    matchStyle: matchStyle,
    matchElement: Tag
  }), renderPlain && text, renderDirectHighlight && Tag && React.createElement(Tag, {
    className: matchClass,
    style: matchStyle
  }, text));
}
Highlighter.defaultProps = {
  caseSensitive: false,
  matchElement: 'strong',
  matchClass: 'highlight',
  matchStyle: {}
};
Highlighter.propTypes = {
  search: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, regExpPropTypes]).isRequired,
  caseSensitive: PropTypes.bool,
  matchElement: PropTypes.string,
  matchClass: PropTypes.string,
  matchStyle: PropTypes.object,
  text: PropTypes.string.isRequired,
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object
};